import { api } from ":mods";
import { ENDPOINTS } from "../const";

export async function getCountries() {
  return api.getAuth(ENDPOINTS.get_countries).then(async (res) => {
    return Promise.resolve(res.data);
  });
}
